(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cj-cart-promo-banner"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cart-promo-banner')) {
    customElements.define('cart-promo-banner', class extends HTMLElement {
      connectedCallback() {
        const drawer = this.closest('cart-drawer-component');
        const footer = this.closest('[get-element-height]');
        if (!drawer || !footer) return;

        this.resizeObserver = new ResizeObserver(() => {
          drawer.style.setProperty('--set-container-height', `${footer.offsetHeight}px`);
        });
        this.resizeObserver.observe(footer);
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cj-mega-navigation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cj-mega-navigation')) {
    customElements.define('cj-mega-navigation', class extends HTMLElement {
      connectedCallback() {
        if (this.listeners) return;
        this.listeners = new AbortController();
        const options = { signal: this.listeners.signal };
        const updateCurrentLinks = () => {
          this.querySelectorAll('a[href]').forEach(link => {
            const url = new URL(link.href, location.origin);
            if (url.origin === location.origin && url.pathname === location.pathname) link.setAttribute('aria-current', 'page');
            else link.removeAttribute('aria-current');
          });
        };
        updateCurrentLinks();
        document.addEventListener('cj:collection-change', updateCurrentLinks, options);
        const details = [...this.querySelectorAll('details')];
        const close = (except) => details.forEach(item => { if (item !== except) item.open = false; });
        details.forEach(item => {
          item.addEventListener('toggle', () => { if (item.open) close(item); }, options);
          item.addEventListener('pointerenter', event => {
            if (this.dataset.mode !== 'desktop' || event.pointerType !== 'mouse') return;
            clearTimeout(this.closeTimer);
            close(item);
            item.open = true;
          }, options);
          item.addEventListener('pointerleave', event => {
            if (this.dataset.mode !== 'desktop' || event.pointerType !== 'mouse') return;
            this.closeTimer = setTimeout(() => { if (!item.contains(document.activeElement)) item.open = false; }, 180);
          }, options);
          item.addEventListener('focusout', event => {
            if (!item.contains(event.relatedTarget)) item.open = false;
          }, options);
          item.querySelector('summary').addEventListener('keydown', event => {
            if (event.key !== 'ArrowDown') return;
            event.preventDefault();
            close(item);
            item.open = true;
            item.querySelector('a')?.focus();
          }, options);
        });
        this.addEventListener('keydown', event => {
          if (event.key !== 'Escape') return;
          const opened = event.target.closest('details[open]');
          if (!opened) return;
          event.preventDefault();
          event.stopPropagation();
          opened.open = false;
          opened.querySelector('summary').focus();
        }, options);
        document.addEventListener('pointerdown', event => { if (!this.contains(event.target)) close(); }, options);
        window.addEventListener('resize', () => close(), options);
      }
      disconnectedCallback() {
        clearTimeout(this.closeTimer);
        this.listeners?.abort();
        this.listeners = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cj-product-image-badge"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cj-image-badges')) {
    customElements.define('cj-image-badges', class extends HTMLElement {
      connectedCallback() {
        this.onVisibility = () => this.updateBadges();
        document.addEventListener('visibilitychange', this.onVisibility);
        this.updateBadges();
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        document.removeEventListener('visibilitychange', this.onVisibility);
      }

      updateBadges() {
        clearTimeout(this.timer);
        const now = Date.now() / 1000;
        const badges = [...this.querySelectorAll('[data-badge-id]')];
        let selected = null;
        let nextChange = Infinity;
        for (const badge of badges) {
          const start = Number(badge.dataset.start);
          const end = Number(badge.dataset.end);
          const priority = Number(badge.dataset.priority);
          if (!Number.isFinite(start) || !Number.isFinite(end) || !Number.isFinite(priority)) continue;
          if (start && end && end <= start) continue;
          if (start > now) nextChange = Math.min(nextChange, start);
          if (end > now) nextChange = Math.min(nextChange, end);
          if (start > now || (end && end <= now)) continue;
          if (
            !selected ||
            priority < Number(selected.dataset.priority) ||
            (priority === Number(selected.dataset.priority) && start > Number(selected.dataset.start))
          ) selected = badge;
        }
        for (const badge of badges) badge.hidden = badge !== selected;
        if (Number.isFinite(nextChange)) {
          const delay = Math.min(2147483647, Math.max(1, Math.ceil((nextChange - now) * 1000)));
          this.timer = setTimeout(() => this.updateBadges(), delay);
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cj-shopping-preferences"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cj-shopping-preferences')) {
    customElements.define('cj-shopping-preferences', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        const dialog = this.querySelector('dialog');
        const trigger = this.querySelector('[data-preferences-open]');
        const country = this.querySelector('[data-preferences-country]');
        const currency = this.querySelector('output');
        trigger.addEventListener('click', () => {
          dialog.showModal();
          trigger.setAttribute('aria-expanded', 'true');
          country.focus();
        });
        country.addEventListener('change', () => {
          currency.textContent = country.selectedOptions[0]?.dataset.currency || '';
        });
        dialog.addEventListener('keydown', (event) => {
          if (event.key !== 'Tab') return;
          const controls = [...dialog.querySelectorAll('button, select, input:not([type="hidden"])')].filter(control => !control.disabled);
          const first = controls[0];
          const last = controls[controls.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        });
        this.querySelector('[data-preferences-close]').addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', (event) => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        });
        dialog.addEventListener('close', () => {
          trigger.setAttribute('aria-expanded', 'false');
          trigger.focus();
        });
        this.initialized = true;
        trigger.disabled = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cj-two-row-products"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cj-two-row-products')) {
    customElements.define('cj-two-row-products', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.tabs = [...this.querySelectorAll('[data-best-tab]')];
        this.panels = [...this.querySelectorAll('[data-best-panel]')];
        this.states = this.panels.map(panel => ({ panel, track: panel.querySelector('[data-best-track]'), items: [...panel.querySelectorAll('[data-best-item]')], page: 0, size: 0 }));
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(index), { signal });
          tab.addEventListener('keydown', event => {
            let next = index;
            if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
            else if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = this.tabs.length - 1;
            else return;
            event.preventDefault();
            this.select(next);
            this.tabs[next].focus({ preventScroll: true });
          }, { signal });
        });
        this.states.forEach(state => {
          if (!state.track) return;
          const { track, panel } = state;
          panel.querySelector('[data-best-prev]').addEventListener('click', () => this.go(state, state.page - 1), { signal });
          panel.querySelector('[data-best-next]').addEventListener('click', () => this.go(state, state.page + 1), { signal });
          track.addEventListener('scroll', () => {
            cancelAnimationFrame(state.frame);
            state.frame = requestAnimationFrame(() => this.update(state));
          }, { passive: true, signal });
          track.addEventListener('keydown', event => {
            if (event.target !== track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
            event.preventDefault();
            const page = event.key === 'Home' ? 0 : event.key === 'End' ? state.pages - 1 : state.page + (event.key === 'ArrowRight' ? 1 : -1);
            this.go(state, page);
          }, { signal });
          track.addEventListener('dragstart', event => event.preventDefault(), { signal });
          track.addEventListener('pointerdown', event => {
            if (event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('button,input,select')) return;
            state.suppressClick = false;
            state.drag = { id: event.pointerId, start: event.clientX, left: track.scrollLeft, moved: false };
          }, { signal });
          track.addEventListener('pointermove', event => {
            const drag = state.drag;
            if (!drag || drag.id !== event.pointerId) return;
            const delta = event.clientX - drag.start;
            if (!drag.moved && Math.abs(delta) < 8) return;
            drag.moved = true;
            track.setPointerCapture(event.pointerId);
            track.classList.add('is-dragging');
            event.preventDefault();
            track.scrollLeft = drag.left - delta;
          }, { signal });
          const finishDrag = event => {
            const drag = state.drag;
            if (!drag || drag.id !== event.pointerId) return;
            state.drag = null;
            state.suppressClick = drag.moved;
            if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
            track.classList.remove('is-dragging');
            if (drag.moved) this.go(state, Math.round(track.scrollLeft / this.step(state)));
          };
          track.addEventListener('pointerup', finishDrag, { signal });
          track.addEventListener('pointercancel', finishDrag, { signal });
          track.addEventListener('lostpointercapture', finishDrag, { signal });
          track.addEventListener('click', event => {
            if (!state.suppressClick) return;
            event.preventDefault();
            event.stopImmediatePropagation();
            state.suppressClick = false;
          }, { capture: true, signal });
        });
        this.resize = new ResizeObserver(() => this.layout());
        this.resize.observe(this);
        document.addEventListener('shopify:block:select', event => {
          const index = this.tabs.findIndex(tab => tab.dataset.bestTab === event.detail?.blockId);
          if (index !== -1) this.select(index);
        }, { signal });
        this.layout();
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.resize?.disconnect();
        this.states?.forEach(state => cancelAnimationFrame(state.frame));
      }
      step(state) {
        return state.track.clientWidth + (parseFloat(getComputedStyle(state.track).columnGap) || 0);
      }
      layout() {
        const size = matchMedia('(max-width: 749px)').matches ? 4 : 8;
        this.states.forEach(state => {
          if (!state.track || state.panel.hidden) return;
          const first = state.page * (state.size || size);
          state.size = size;
          state.pages = Math.ceil(state.items.length / size);
          state.page = Math.min(Math.floor(first / size), state.pages - 1);
          state.track.scrollTo({ left: state.page * this.step(state), behavior: 'instant' });
          this.update(state);
        });
      }
      select(index) {
        this.tabs.forEach((tab, i) => {
          tab.classList.toggle('active', i === index);
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
        });
        this.panels.forEach((panel, i) => { panel.hidden = i !== index; });
        const url = this.tabs[index]?.dataset.viewallUrl;
        this.closest('[featured-collection]')?.querySelectorAll('[viewall-link]').forEach(link => {
          link.classList.toggle('d-none', !url);
          if (url) link.href = url;
        });
        this.layout();
      }
      go(state, page) {
        const next = Math.max(0, Math.min(page, state.pages - 1));
        state.track.scrollTo({ left: next * this.step(state), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
      update(state) {
        if (!state.size || state.panel.hidden) return;
        state.page = Math.max(0, Math.min(state.pages - 1, Math.round(state.track.scrollLeft / this.step(state))));
        const { panel, page, pages, size } = state;
        panel.querySelector('[data-best-controls]').hidden = pages <= 1;
        panel.querySelector('[data-best-prev]').disabled = page === 0;
        panel.querySelector('[data-best-next]').disabled = page === pages - 1;
        panel.querySelector('[data-best-progress]').style.width = `${(page + 1) / pages * 100}%`;
        const status = panel.querySelector('[data-best-status]');
        const text = `${page + 1} / ${pages}`;
        if (status.textContent !== text) {
          status.textContent = text;
          status.setAttribute('aria-label', status.dataset.pageLabel.replace('[current]', page + 1).replace('[total]', pages));
        }
        state.items.forEach((item, index) => { item.inert = index < page * size || index >= (page + 1) * size; });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
